import { render, staticRenderFns } from "./teamManagementTeam.vue?vue&type=template&id=6464b222&scoped=true&"
import script from "./teamManagementTeam.vue?vue&type=script&lang=ts&"
export * from "./teamManagementTeam.vue?vue&type=script&lang=ts&"
import style0 from "./teamManagementTeam.vue?vue&type=style&index=0&id=6464b222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464b222",
  null
  
)

export default component.exports